import React from "react";

function MobileIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="11"
      height="15"
      viewBox="0 0 11 15"
      fill="none"
    >
      <path
        d="M0.6875 2.25C0.6875 1.28477 1.47227 0.5 2.4375 0.5H8.5625C9.52773 0.5 10.3125 1.28477 10.3125 2.25V12.75C10.3125 13.7152 9.52773 14.5 8.5625 14.5H2.4375C1.47227 14.5 0.6875 13.7152 0.6875 12.75V2.25ZM4.1875 12.75C4.1875 12.9906 4.38438 13.1875 4.625 13.1875H6.375C6.61562 13.1875 6.8125 12.9906 6.8125 12.75C6.8125 12.5094 6.61562 12.3125 6.375 12.3125H4.625C4.38438 12.3125 4.1875 12.5094 4.1875 12.75ZM8.5625 2.25H2.4375V11H8.5625V2.25Z"
        fill="#277DFE"
      />
    </svg>
  );
}

export default MobileIcon;
